import(/* webpackMode: "eager", webpackExports: ["FeaturesPageContent"] */ "/app/components/frontend/features/features-page-content.tsx");
